import "./components/prepareAlpine.js";
import "./components/lenis.js";

import Alpine from 'alpinejs';

import './components/store/app';

import accordion from './components/accordion';
Alpine.data('accordion', accordion);

import header from './components/header';
Alpine.data('header', header);

import marquee from './components/marquee';
Alpine.data('marquee', marquee);

import slide from './components/slide';
Alpine.data('slide', slide);

import rotate from './components/rotate';
Alpine.data('rotate', rotate);

import scrollReveal from './components/scrollReveal';
Alpine.data('scrollReveal', scrollReveal);

import orbitTicks from './components/orbitTicks';
Alpine.data('orbitTicks', orbitTicks);

import newsfeed from './components/newsfeed';
Alpine.data('newsfeed', newsfeed);

import ingredientsCarousel from './components/ingredientsCarousel';
Alpine.data('ingredientsCarousel', ingredientsCarousel);

import pill from './components/pill';
Alpine.data('pill', pill);

import dialog from './components/dialog';
Alpine.data('dialog', dialog);

import tooltip from './components/tooltip';
Alpine.data('tooltip', tooltip);

import stickyBuyBtn from './components/stickyBuyBtn';
Alpine.data('stickyBuyBtn', stickyBuyBtn);

window.Alpine = Alpine;
Alpine.start();
